import RestService from "./rest.service";

class faqsService {
  faqs() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getFaqs("app/kpi/support/faqs").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  faqstype() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getFaqType("app/kpi/support/typefaqs").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  insertfaq(type ,description ,email) {
    const oData = {
      type:type,
      description:description,
      email: email
    };
    return new Promise((fnResolve, fnReject) => {
      RestService.addFaq("app/kpi/support/faq", oData).then(
        (response) => {
          fnResolve(response);
        },
        (err) => {
          fnReject(err);
        }
      );
    });
  }

  
  supporttype() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getSupportType("app/kpi/support/typesupport").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

 }



export default new faqsService();
